class Game {
  constructor() {
    this.id = 0;
    this.title = '';
    this.timestamp = 0;
    this.date = '';
    this.time = '';
    this.dateLocal = '';
    this.timeLocal = '';
    this.dayDiff = null;
    this.category = '';
    this.gender = '';
    this.level = '';
    this.state = '';
    this.status = '';
    this.location = {
      name: '',
      country: '',
      city: '',
      region: '',
      lat: '',
      lon: '',
    };
    this.teams = {
      home: {},
      away: {},
    };
    this.sport = '';
    this.squad = '';
    this.url = '';
  }

  getId() {
    return this.id;
  }

  setId(id) {
    this.id = id;

    return this;
  }

  getTitle() {
    return this.title;
  }

  setTitle(title) {
    this.title = title;

    return this;
  }

  getTimestamp() {
    return this.timestamp;
  }

  setTimestamp(timestamp) {
    this.timestamp = timestamp;

    return this;
  }

  getDate() {
    return this.date;
  }

  setDate(date) {
    this.date = date;

    return this;
  }

  getTime() {
    return this.time;
  }

  setTime(time) {
    this.time = time;

    return this;
  }

  getLocalDate() {
    return this.dateLocal;
  }

  setLocalDate(localDate) {
    this.dateLocal = localDate;

    return this;
  }

  getLocalTime() {
    return this.timeLocal;
  }

  setLocalTime(localTime) {
    this.timeLocal = localTime;

    return this;
  }

  setDayDiff(dayDiff) {
    this.dayDiff = dayDiff;

    return this;
  }

  getDayDiff() {
    return this.dayDiff;
  }

  getCategory() {
    return this.category;
  }

  setCategory(category) {
    this.category = category;

    return this;
  }

  getGender() {
    return this.gender;
  }

  setGender(gender) {
    this.gender = gender;

    return this;
  }

  getLevel() {
    return this.level;
  }

  setLevel(level) {
    this.level = level;

    return this;
  }

  getState() {
    return this.state;
  }

  setState(state) {
    this.state = state;

    return this;
  }

  getStatus() {
    return this.status;
  }

  setStatus(status) {
    this.status = status;

    return this;
  }

  getLocation() {
    return this.location;
  }

  setLocation(location) {
    this.location = location;

    return this;
  }

  hasLocation() {
    return this.getLocation();
  }

  getHomeTeam() {
    return this.teams.home;
  }

  setHomeTeam(team) {
    this.teams.home = team;

    return this;
  }

  getAwayTeam() {
    return this.teams.away;
  }

  setAwayTeam(team) {
    this.teams.away = team;

    return this;
  }

  getSport() {
    return this.sport;
  }

  setSport(sport) {
    this.sport = sport;

    return this;
  }

  getSquad() {
    return this.squad;
  }

  setSquad(squad) {
    this.squad = squad;

    return this;
  }

  hasSquad() {
    return this.getSquad();
  }

  getUrl() {
    return this.url;
  }

  hasUrl() {
    return this.url.length > 0;
  }

  setUrl(url) {
    this.url = url;

    return this;
  }

  async getBroadcast() {
    const query = {
      teams: [this.getHomeTeam().getWpid(), this.getAwayTeam().getWpid()],
      gender: this.getGender(),
      level: this.getLevel(),
      sport: this.getSport(),
      timestamp: this.getTimestamp(),
    };

    return await window.bvm.app.games.getBroadcast(query);
  }
}

export default Game;
